import { Device } from 'twilio-client'

const twilioDevice = new Device()

export default twilioDevice
